/**
 * @generated SignedSource<<0aaaab3b69ab31c1d31edf693e4bb803>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type diligenceMatrixTables_Query$variables = {
  band?: string | null | undefined;
  dimension?: string | null | undefined;
};
export type diligenceMatrixTables_Query$data = {
  readonly diligenceMatrix: {
    readonly available: boolean;
    readonly generatedAt: any | null | undefined;
    readonly months: ReadonlyArray<string>;
    readonly notes: ReadonlyArray<string>;
    readonly rows: ReadonlyArray<{
      readonly band: string;
      readonly dimension: string;
      readonly drillable: boolean;
      readonly format: string;
      readonly group: string;
      readonly key: string;
      readonly label: string;
      readonly mom: ReadonlyArray<number | null | undefined>;
      readonly ttm: ReadonlyArray<number | null | undefined>;
    }>;
    readonly segments: ReadonlyArray<{
      readonly band: string;
      readonly dimension: string;
      readonly label: string;
    }>;
  };
};
export type diligenceMatrixTables_Query = {
  response: diligenceMatrixTables_Query$data;
  variables: diligenceMatrixTables_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "band"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dimension"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dimension",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "band",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "band",
        "variableName": "band"
      },
      {
        "kind": "Variable",
        "name": "dimension",
        "variableName": "dimension"
      }
    ],
    "concreteType": "DiligenceMatrix",
    "kind": "LinkedField",
    "name": "diligenceMatrix",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "available",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "generatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "months",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "notes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DiligenceMatrixSegment",
        "kind": "LinkedField",
        "name": "segments",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DiligenceMatrixRow",
        "kind": "LinkedField",
        "name": "rows",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "group",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "format",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "drillable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ttm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mom",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "diligenceMatrixTables_Query",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "diligenceMatrixTables_Query",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "29ed66c711fc23499bb8cfdd38560a9b",
    "id": null,
    "metadata": {},
    "name": "diligenceMatrixTables_Query",
    "operationKind": "query",
    "text": "query diligenceMatrixTables_Query(\n  $dimension: String\n  $band: String\n) {\n  diligenceMatrix(dimension: $dimension, band: $band) {\n    available\n    generatedAt\n    months\n    notes\n    segments {\n      dimension\n      band\n      label\n    }\n    rows {\n      key\n      label\n      group\n      format\n      dimension\n      band\n      drillable\n      ttm\n      mom\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c427b95fadfec283cf5e3328d90dd1d";

export default node;
